import { zodContract } from '@leprecoins/effector-sockets';
import { createReceive } from '../socket-client';
import { connectionSchema } from '../types';

export const receiveConnection = createReceive('connection', zodContract(connectionSchema));
